<script setup lang="ts">
import cookie from 'js-cookie'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useApp } from '@/stores/app.stores'
import { useAuthStore } from '@/stores/auth.stores'

const store = useStore()
const router = useRouter()
const authStore = useAuthStore()
const appStore = useApp()

onMounted(async () => {
  cookie.remove('store_info')
  cookie.remove('advertiserId')
  await store.dispatch('user/clearUser')

  const logoutUrl = await authStore.logout()
  appStore.terminate()
  if (logoutUrl) {
    window.location.href = logoutUrl
    return
  } else {
    await router.push({ name: 'login' })
  }
})
</script>
<template>
  <div></div>
</template>
